import {
  SET_PENDING_TRANSACTIONS,
  SET_MULTIPLE_PENDING_TRANSACTIONS,
  OVERRIDE_PENDING_TRANSACTIONS
} from '../actions/types';

let initialState = {transactions:{}, transfers: {}};
try {
  initialState.transactions = window.getStorage("pendingTransactions") ? window.getStorage("pendingTransactions") : {};
  initialState.transfers = window.getStorage("pendingTransactions")  ? window.getStorage("pendingTransactions") : {}

  if(initialState.transactions === null) initialState.transactions = {};
  if(initialState.transfers === null) initialState.transferss = {};
} catch(err){

}

export default function(state: Object = initialState, action) {
  switch(action.type) {
    case OVERRIDE_PENDING_TRANSACTIONS:
      let {pendingTransactions, pendingTransfers} = action.payload;
      console.log({pendingTransactions,pendingTransfers})
      console.log(Object.keys(pendingTransactions).length)
      console.log(JSON.stringify(pendingTransactions))
      window.setStorage("pendingTransactions",JSON.stringify(pendingTransactions));

      if(pendingTransfers){
        window.setStorage("pendingTransfers",JSON.stringify(pendingTransfers));
        return {...state, transactions:pendingTransactions,transfers:pendingTransfers};
      }
      else {
        return {...state, transactions:pendingTransactions};
      }

    case SET_MULTIPLE_PENDING_TRANSACTIONS:
      let transactions = state.transactions;
      let transfers = state.transfers;

      for(let tx of action.payload){
        tx.time = Date.now()
        transactions[tx.hash] = tx;
        if(tx.txHash) transfers[`${tx.txHash}.${tx.txOutputIndex}`] = tx;
      }
      window.setStorage("pendingTransfers",JSON.stringify(transfers));
      window.setStorage("pendingTransactions",JSON.stringify(transactions));
      return {...state, transactions, transfers};

    case SET_PENDING_TRANSACTIONS:
      transactions = state.transactions;
      transfers = state.transfers;

      let tx = action.payload;
      tx.time = Date.now()
      transactions[tx.hash] = tx;
      if(tx.txHash) transfers[`${tx.txHash}.${tx.txOutputIndex}`] = tx;

      window.setStorage("pendingTransfers",JSON.stringify(transfers));
      window.setStorage("pendingTransactions",JSON.stringify(transactions));
      return {...state, transactions, transfers};

    default:
      return state;
  }
}
